import { log } from "../../engine/logger/logger";
import { Actor, WieldMode } from "../actors/Actor";
import Colors from "../Colors";
import { gameData, getItemsForPosition } from "../GameManager";
import { getActorWeight, getWeightLoad } from "../items/formulas";
import {
  dropMsg,
  pickupMsg,
  takeOffMsg,
  wearArmorMsg,
  wield1hMsg,
  wield2hMsg,
} from "../messages/ItemMessages";

const weightCheck = (actor: Actor) => {
  const load = getWeightLoad(getActorWeight(actor), actor.attributes.weight);
  if (actor === gameData.player && 100 <= load) {
    log(
      `%c{${Colors.B_GREY_5}}You are overencumbered (${load}%). Exhaustion drains your stamina.`
    );
  }
};

export const stanceChange = (actor: Actor) => {
  if (actor.wielding.mode === WieldMode.oneHanded) {
    wield2hMsg(actor);
    actor.wielding.mode = WieldMode.twoHanded;
  } else {
    wield1hMsg(actor);
    actor.wielding.mode = WieldMode.oneHanded;
  }
  return { valid: true };
};

export const wieldWeapon = (
  actor: Actor,
  { left, right }: { left?: number; right?: number }
) => {
  const swapToRight = right != null && right === actor.wielding.left?.id;
  const swapToLeft = left != null && left === actor.wielding.right?.id;
  let newLeft =
    left != null &&
    (swapToLeft ? actor.wielding.right : actor.contains.remove(left as number));
  let newRight =
    right != null &&
    (swapToRight
      ? actor.wielding.left
      : actor.contains.remove(right as number));
  const oldRight = actor.wielding.right;
  const oldLeft = actor.wielding.left;

  if (oldRight?.id === right) {
    newRight = oldRight;
  }

  if (oldLeft?.id === left) {
    newLeft = oldLeft;
  }

  console.log(
    left,
    right,
    swapToRight,
    swapToLeft,
    oldLeft,
    newLeft,
    oldRight,
    newRight
  );
  if (oldLeft && oldLeft !== newLeft) {
    oldLeft.removeStats(actor);
    if (!swapToRight) {
      actor.contains.add(oldLeft.id, oldLeft);
    }
  }

  if (oldRight && (swapToRight || oldRight !== newRight)) {
    oldRight.removeStats(actor);
    if (!swapToLeft) {
      actor.contains.add(oldRight.id, oldRight);
    }
  }

  actor.wielding.left = newLeft || null;
  if (newLeft) {
    newLeft.applyStats(actor);
  }
  actor.wielding.right = newRight || null;
  if (newRight) {
    newRight.applyStats(actor);
  }

  const newSecond =
    (oldLeft && !oldRight && left == null && newRight) ||
    (oldRight && !oldLeft && right == null && newLeft);

  if ((left != null && right != null) || newSecond) {
    actor.wielding.mode = WieldMode.oneHanded;
  }

  if (actor.wielding.mode === WieldMode.oneHanded) {
    wield1hMsg(actor);
  } else {
    wield2hMsg(actor);
  }

  weightCheck(actor);
  return { valid: true };
};

export const wearArmor = (actor: Actor, { id }: { id: number }) => {
  const holding = actor.wearing.armor;
  if (holding) {
    takeOffMsg(actor, holding);
    holding.removeStats(actor);
    actor.contains.add(holding.id, holding);
  }

  const item = actor.contains.remove(id);
  if (item) {
    actor.wearing.armor = item;
    wearArmorMsg(actor);
    item.applyStats(actor);
  } else {
    actor.wearing.armor = null;
  }
  weightCheck(actor);
  return { valid: true };
};

export const pickupItem = (actor: Actor, { id }: { id: number }) => {
  const item = gameData.items.remove(id);
  if (item) {
    if (!item.everHeld) {
      const q = gameData.current.lootTable.get(item.breed.key);
      if (q) {
        gameData.current.lootTable.set(item.breed.key, q - 1);
      } else {
        console.warn("wanted to adjust loot table for item with no quantity");
      }
    }
    item.everHeld = true;
    actor.contains.add(item.id, item);
    pickupMsg(actor, item);
    return { valid: true };
  }
  return { valid: false };
};

export const dropItem = (actor: Actor, { id }: { id: number }) => {
  const item = actor.contains.remove(id);
  if (item) {
    item.x = actor.x;
    item.y = actor.y;
    gameData.items.add(item.id, item);
    dropMsg(actor, item);
    return { valid: true };
  }
  return { valid: false };
};

export const useItem = (actor: Actor, { id }: { id: number }) => {
  const item = actor.contains.get(id);
  if (item) {
    item.useItem(actor);
    return { valid: true };
  }
  return { valid: false };
};

export const interact = async (actor: Actor) => {
  const items = getItemsForPosition(actor.x, actor.y).filter(
    (item) => item.breed.interact
  );
  if (items.length) {
    for (let i = 0; i < items.length; i++) {
      log(
        `You pray at the shrine, but no one answers. The world shifts around you.`
      );
      log(`You fill your flask of restoration (%c{${Colors.RED_4}}u%c{})`);
      await items[i].interact(actor);
    }
  }
  return { valid: true };
};
